export default __webpack_public_path__ + "static/media/Cloudxier-Ausmincham-website.d394c1dd.jpg";